import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    q: "What is ABA therapy?",
    a: "Applied Behavior Analysis (ABA) is an evidence-based approach that uses positive reinforcement to build communication, social, play and daily-living skills. At NeuroNest, every programme is one-to-one and tailored to your child.",
  },
  {
    q: "At what age should we consider an early intervention assessment?",
    a: "The earlier, the better — often between 18 months and 6 years. If you notice delays in speech, social interaction or play, an assessment gives you a clear, compassionate picture and a practical plan. There's no harm in checking early.",
  },
  {
    q: "How long are the sessions and how often?",
    a: "Session length and frequency depend on your child's individual plan. After the initial assessment we recommend a schedule together, and we adjust it as your child grows and progresses.",
  },
  {
    q: "Will I be involved in my child's therapy?",
    a: "Absolutely. Parents are part of the team. We coach and equip you with strategies so the progress continues at home, and we share regular updates on how your child is doing.",
  },
  {
    q: "Do I need a referral or diagnosis to book?",
    a: "No referral is required to book an assessment. Simply send us an enquiry or call, and we'll guide you through the next steps warmly and clearly.",
  },
  {
    q: "Where is the clinic located?",
    a: "We're on 90 Feet Road, Ahmednagar, open Monday to Friday, 11:00 am to 6:00 pm. You'll find a map on this page and our contact details just below.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const FAQ = () => {
  return (
    <section id="faq" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.4 }}
            className="lg:col-span-4"
          >
            <p className="text-sm tracking-[0.2em] uppercase text-brand-secondary mb-5">Questions</p>
            <h2 className="font-display font-light text-4xl sm:text-5xl tracking-tight text-brand-primary leading-tight">
              Answers for caring parents.
            </h2>
            <p className="mt-6 text-brand-ink/70 leading-relaxed">
              Still unsure about something? Reach out — we're always happy to talk it through.
            </p>
          </motion.div>

          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.2 }}
            className="lg:col-span-8"
          >
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-brand-primary/10"
                >
                  <AccordionTrigger className="font-display text-lg sm:text-xl text-brand-primary hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-brand-ink/70 text-base leading-relaxed pb-6 pr-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
